import { useExperiment } from 'statsig-react';

import type { ActiveExperiments } from '../consts/activeExperiments';

const useStatsigExperiment = (experimentName: ActiveExperiments) => {
  const { config } = useExperiment(experimentName, true);
  const { value } = config;
  //if the user fails to pass a feature gate in the experiment, the group with return null/undefined and we will default to control
  const group = config.getGroupName() ?? 'Control';

  return { experience: group, value };
};
export default useStatsigExperiment;
